/* eslint-disable import/prefer-default-export */

import {
  FIRST_NAME,
  LAST_NAME,
  MEMBER_NUMBER,
  EMPLOYEE_NUMBER,
} from '../../utils/form-constants';
import { CONTACT_US } from '../../utils/url-constants';

export const EMPLOYEE_NAME_MISMATCH_ERROR = {
  firstHalf: '<strong>Your member name must match your employee name on file.</strong> To continue, ',
  link: {
    analyticsId: 'applet_employee error contact us',
    href: `https://www.rei.com${CONTACT_US}`,
    text: 'contact us',
  },
  secondHalf: ' to update your information.',
};
export const EMPLOYEE_NUMBER_MISMATCH_ERROR = {
  firstHalf: '<strong>The employee number you entered doesn’t match our records.</strong> Please double-check your entry and access ',
  link: {
    analyticsId: 'applet_Sign into HR portal',
    href: 'https://reiweb.sharepoint.com/',
    text: 'HR Self-Service',
  },
  secondHalf: ' if you continue to have problems.',
};

export const CONFIRM_MEMBERSHIP_FORM = [
  {
    ...FIRST_NAME,
    id: 'memberFirstName',
  },
  {
    ...LAST_NAME,
    id: 'memberLastName',
  },
  {
    ...MEMBER_NUMBER,
    id: 'memberId',
  },
];

export const CONFIRM_EMPLOYEE_INFO_FORM = {
  ...EMPLOYEE_NUMBER,
  id: 'empId',
};
